import Raven from 'raven-js';
export default function makeRequest({
  fetch,
  payload,
  requestActions
}) {
  return dispatch => {
    dispatch(requestActions.request(payload));
    return fetch(payload).then(resp => {
      return dispatch(requestActions.receive(resp, payload));
    }).catch(err => {
      dispatch(requestActions.failure(err, payload));
      Raven.captureException(err);
    });
  };
}